export default __webpack_public_path__ + "static/media/NotoSans-Medium.7bae19c5.woff";